// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a1cde9df","346":"4667c66f","419":"b64fa9a5","498":"2e8d7b5f","563":"4a64f445","643":"e8acd927","684":"97daf310","703":"95e551a0","778":"e9d89aca"}[chunkId] + ".chunk.js";
};